import React from "react";
import dynamic from "next/dynamic";

const AnyReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export default function RenderVideo({
  url,
  controls,
}: {
  url?: string;
  controls?: boolean;
}) {
  const videoUrl = url ?? "https://www.youtube.com/watch?v=iGQ2-cipR9w";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        marginBottom: 20,
      }}
      className="h-[220px] md:h-[500px] w-full"
    >
      <AnyReactPlayer
        height={"100%"}
        width={"100%"}
        controls={controls ?? false}
        style={{
          width: "100%",
          height: "100%",
        }}
        src={videoUrl}
      />
    </div>
  );
}
